import { css } from "styled-components";

import { colors } from "@ntemarked/mittne-components";

// Global skjemastil gir ingen egen stil for låste felt, så de ville sett redigerbare ut. Den setter hvit
// bakgrunn med en selektor (input:not(...) x6) som slår klassen her, derav !important.
// Egen modul fordi CreateSikringPage og stegene importerer hverandre, og stilen leses når modulen lastes.
export const disabledInputStyle = css`
	background: ${colors.grey300} !important;
	color: ${colors.grey700};
	cursor: not-allowed;
`;
